export default function EdgeWarning(props: { children: React.ReactNode }) {
    const isEdge = window.location.hostname.includes("-edge") || window.location.hostname.startsWith("stahls-art")
    return isEdge ? <div style={{ backgroundColor: "pink" }}>
        {props.children}
    </div> : <>{props.children}</>

}